module.exports = __webpack_public_path__ + "assets/apo-logo-big.9111fe44.jpg";